import React from 'react';
import { classNames } from '../../utils/classNames';

export const Skeleton = ({ className, rounded = 'rounded-xl', tone = 'default' }) => (
  <div
    className={classNames(
      'skeleton-shimmer',
      tone === 'onAccent' && 'skeleton-shimmer-on-accent',
      rounded,
      className
    )}
    aria-hidden="true"
  />
);
